import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';

// Pages
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <FloatingCTA />
      <div className="flex flex-col min-h-screen bg-white text-brand-text antialiased">
        {/* Navigation Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            {/* Forside */}
            <Route path="/" element={<Home />} />

            {/* Ydelser */}
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />

            {/* Om os */}
            <Route path="/om-os" element={<About />} />

            {/* Kontakt */}
            <Route path="/kontakt" element={<Contact />} />

            {/* 403 Forbidden */}
            <Route path="/403" element={<Forbidden />} />

            {/* 404 Not Found */}
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
